import PropTypes from 'prop-types';

import { DefaultAvatar as Avatar, PROFILE_TYPE_GROUP } from '@/components/base/Avatar';
// Components
import Icon from '@/components/base/Icon';
import Select from '@/components/base/Select';

const SelectWithGroupIcon = ({
    error,
    disabled,
    selected,
    value,
    noValue = false,
    groupData = {},
    baseStyle = 'noBorder',
    avatarSize = 'sm',
    sizeStyle = 'default',
    avatarGroupIcon = false,
    className
}) => {
    return (
        <Select.Button
            selected={selected}
            sizeStyle={sizeStyle}
            disabled={disabled}
            baseStyle={baseStyle ?? 'noBorder'}
            error={error}
            className={className}>
            <div
                className="flex items-center space-x-3"
                data-testid="select-with-group-icon-button">
                {selected?.value === 'all' ? (
                    <Icon className="text-base text-icoBlue" icon="group" />
                ) : (
                    <Avatar
                        size={avatarSize}
                        radius="rounded-m"
                        profileType={avatarGroupIcon ? PROFILE_TYPE_GROUP : null}
                        url={groupData?.image ?? null}
                        fallback={groupData?.name?.substring(0, 2)}
                        customColorClass={groupData?.fallback_style}
                    />
                )}
                {!noValue ? (
                    <div className="flex flex-col space-y-0.5 overflow-hidden">
                        <span className="block flex-1 truncate text-icoBlack dark:text-white">
                            {value ?? selected?.label ?? selected?.value}
                        </span>
                    </div>
                ) : null}
            </div>
        </Select.Button>
    );
};
SelectWithGroupIcon.propTypes = {
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    disabled: PropTypes.bool,
    selected: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    value: PropTypes.string,
    groupData: PropTypes.object,
    baseStyle: PropTypes.string,
    avatarSize: PropTypes.string,
    avatarGroupIcon: PropTypes.bool,
    className: PropTypes.string
};

export default SelectWithGroupIcon;
